import Script from "next/script";
import Link from 'next/link'
import { loadScripts } from "@/lib/loadContactScripts";
import { useEffect } from "react";

export default function ContactBrevo() {
  useEffect(() => {
    /*
     * The newsletter scripts MUST be loaded after
     * the document is loaded, as they depend on
     * the presence of some elements
     *
     */
    if (document.readyState === "complete") {
      const { resetElements } = loadScripts();

      return () => {
        resetElements();
      };
    } else {
      window.addEventListener("load", loadScripts);
      return () => window.removeEventListener("load", loadScripts);
    }
  }, []);
  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-catalogPosition flex flex-col items-center justify-center mt-8 ">
      <div className="flex flex-col gap-5  items-center font-['Inter'] text-center xl:max-w-8xl">

        <div className="flex flex-col md:flex-row gap-16 sm:px-16 px-8 mt-8">
          <div>
            <link
              rel="stylesheet"
              href="https://sibforms.com/forms/end-form/build/sib-styles.css"
            />
            <style
              dangerouslySetInnerHTML={{
                __html: `
         .sib-form-block {
           padding: 0;
         }

         .entry__field .input::placeholder {
          color: #9ca3af;
         }
        `,
              }}
            />
            <div className="sib-form !px-0 !pt-0">
              <div id="sib-form-container" className="sib-form-container font-sans">
                <div
                  id="sib-container"
                  className="sib-container--large sib-container--vertical !p-0 !bg-transparent"
                >
                  <form
                    id="sib-form"
                    method="POST"
                    action="https://0613d040.sibforms.com/serve/MUIFAB6-QVgFEGOe5tlI5gPEpMuxWxl3rlg4PPABtJ-Fg3JhSUdv0xiBpaBIPPm-X9-Pr1h5UKkrISw4crLI20dMvXzYygcZuPp-qcB-Dl0lfAUIjeFaurvr37fzd1__uNLIUIPvm4suw-IcDoxXnWSMv00egNy40nlgw_vqFl2uxwwtJjbiy0f-s8HQllpD_3rZqUEQ1A78c5H6"
                    data-type="subscription"
                    className="!font-['Inter']"
                  >

                    <div className="ml-4  !font-['Inter'] max-w-4xl">
                      <h1 className="medium-title">Contact Us </h1>
                      <p className="py-3">Contact us via the form below or email at <Link href="mailto:contact@datopian.com" className="font-semibold !text-orange-400" target="_blank">contact@datopian.com</Link>. We&apos;ll respond in 48 hours - valuing your time, always.</p>
                    </div>
                    <div className="py-1 flex items-start gap-4 !px-0">
                      <div className="sib-input sib-form-block grow">
                        <div className="form__entry entry_block">
                          <div className="form__label-row">
                            <div className="entry__field">
                              <input
                                className="input"
                                maxLength={200}
                                type="text"
                                id="FIRSTNAME"
                                name="FIRSTNAME"
                                placeholder="First name"
                                autoComplete="off"
                                data-required="true"
                                title="First name"
                                required=""
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                      <div className="sib-input sib-form-block grow">
                        <div className="form__entry entry_block">
                          <div className="form__label-row ">
                            <div className="entry__field">
                              <input
                                className="input"
                                maxLength={200}
                                type="text"
                                id="LASTNAME"
                                name="LASTNAME"
                                placeholder="Last name"
                                autoComplete="off"
                                data-required="true"
                                title="Last name"
                                required=""
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-input sib-form-block">
                        <div className="form__entry entry_block">
                          <div className="form__label-row ">
                            <div className="entry__field">
                              <input
                                className="input "
                                type="text"
                                id="EMAIL"
                                name="EMAIL"
                                placeholder="Email"
                                autoComplete="off"
                                data-required="true"
                                title="Email"
                                required=""
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-input sib-form-block">
                        <div className="form__entry entry_block">
                          <div className="form__label-row">
                            <div className="entry__field">
                              <input
                                className="input"
                                maxLength={200}
                                type="text"
                                id="COMPANY"
                                name="COMPANY"
                                placeholder="Company / Organization name"
                                autoComplete="off"
                                data-required="true"
                                title="Company"
                                required=""
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-input sib-form-block">
                        <div className="form__entry entry_block">
                          <div className="form__label-row ">
                            <div className="entry__field">
                              <input
                                maxLength={200}
                                type="text"
                                className="input"
                                id="PHONENUMBER"
                                name="PHONENUMBER"
                                placeholder="Phone number"
                                title="phone number"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-select sib-form-block" data-required="true">
                        <div className="form__entry entry_block">
                          <div className="form__label-row">
                            <label
                              className="entry__label font-bold text-left text-base !mb-0"
                              htmlFor="REASON"
                              data-required=""
                            >
                              What brings you to Datopian?
                            </label>
                            <div className="entry__field">
                              <select
                                className="input"
                                id="REASON"
                                name="REASON"
                                data-required="true"
                              >
                                <option value="" disabled="" hidden="">
                                  Select one
                                </option>
                                <option className="sib-menu__item" value={1}>
                                  Publishing data openly
                                </option>
                                <option className="sib-menu__item" value={2}>
                                  Managing internal data
                                </option>
                                <option className="sib-menu__item" value={3}>
                                  CKAN
                                </option>
                                <option className="sib-menu__item" value={4}>
                                  AI Data Services
                                </option>
                              </select>
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-select sib-form-block" data-required="true">
                        <div className="form__entry entry_block">
                          <div className="form__label-row ">
                            <label
                              className="entry__label font-bold text-left text-base !mb-0"
                              htmlFor="CONTACT_HELP_LIST"
                              data-required=""
                            >
                              How can we help?
                            </label>
                            <div className="entry__field">
                              <select
                                className="input"
                                id="CONTACT_HELP_LIST"
                                name="CONTACT_HELP_LIST"
                                data-required="true"
                              >
                                <option value="" disabled="" hidden="">
                                  Select one
                                </option>
                                <option className="sib-menu__item" value={1}>
                                  Hire us
                                </option>
                                <option className="sib-menu__item" value={2}>
                                  Get a quote
                                </option>
                                <option className="sib-menu__item" value={3}>
                                  Request further information
                                </option>
                                <option className="sib-menu__item" value={4}>
                                  Schedule a consultation
                                </option>
                                <option className="sib-menu__item" value={5}>
                                  Query an existing contract
                                </option>
                                <option className="sib-menu__item" value={6}>
                                  Work with us
                                </option>
                                <option className="sib-menu__item" value={7}>
                                  Apply for a job
                                </option>
                              </select>
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-input sib-form-block">
                        <div className="form__entry entry_block">
                          <div className="form__label-row ">
                            <div className="entry__field">
                              <textarea
                                rows={2}
                                className="input"
                                maxLength={500}
                                id="MESSAGE"
                                name="MESSAGE"
                                placeholder="Message"
                                autoComplete="off"
                                data-required="true"
                                title="message"
                                required=""
                                defaultValue={""}
                              />
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div className="sib-optin sib-form-block">
                        <div className="form__entry entry_mcq">
                          <div className="form__label-row ">
                            <div className="entry__choice">
                              <label>
                                <input
                                  type="checkbox"
                                  className="input_replaced"
                                  defaultValue={1}
                                  id="OPT_IN"
                                  name="OPT_IN"
                                />
                                <span className="checkbox checkbox_tick_positive" />
                                <span className="text-base text-left">
                                  <p>
                                    I&apos;d like to be informed about special offers,
                                    news, and exclusive products and services.
                                  </p>
                                </span>{" "}
                              </label>
                            </div>
                          </div>
                          <label className="entry__error entry__error--primary text-sm text-[#661d1d]"></label>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <div
                        className="g-recaptcha"
                        data-sitekey="6LfnC1IkAAAAAF2e32Omr3Vh-_byMLrtYhpv98pm"
                        data-callback="invisibleCaptchaCallback"
                        data-size="invisible"
                        onClick={(e) => this.executeCaptcha(e)}
                      />
                    </div>
                    <div className="py-1">
                      <div className="sib-form-block text-left">
                        <button
                          className="sib-form-block__button sib-form-block__button-with-loader relative w-full sm:w-fit sm:!m-0 text-base text-white font-medium !px-7 !py-3 bg-orange-400 hover:bg-orange-600 border-0 rounded-md"
                          form="sib-form"
                          type="submit"
                          aria-label="submit"
                        >
                          <svg
                            className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon absolute left-1/3"
                            viewBox="0 0 512 512"
                          >
                            <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                          </svg>
                          Submit
                        </button>
                      </div>
                    </div>
                    <input
                      type="text"
                      name="email_address_check"
                      defaultValue=""
                      className="input--hidden"
                      aria-hidden={true}
                    />
                    <input type="hidden" name="locale" defaultValue="en" aria-hidden={true} />
                  </form>
                </div>
                <div
                  id="error-message"
                  className="sib-form-message-panel text-base text-left text-[#661d1d] bg-[#ffeded] border border-[#ff4949] rounded-sm"
                >
                  <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                    <svg
                      viewBox="0 0 512 512"
                      className="sib-icon sib-notification__icon"
                    >
                      <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                    </svg>
                    <span className="sib-form-message-panel__inner-text">
                      Your message could not be sent. Please try again.
                    </span>
                  </div>
                </div>
                <div />
                <div
                  id="success-message"
                  className="sib-form-message-panel text-base text-left text-[#085229] bg-[#e7faf0] border border-[#13ce66] rounded-sm"
                >
                  <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                    <svg
                      viewBox="0 0 512 512"
                      className="sib-icon sib-notification__icon"
                    >
                      <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                    </svg>
                    <span className="sib-form-message-panel__inner-text">
                      Thank you for contacting us! We will get back to you as soon as
                      we can.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <div className="flex flex-col items-center justify-center">
              <div className="relative isolate overflow-hidden bg-maingray mt-6 text-center shadow-2xl rounded-3xl p-8 sm:p-16 md:p-8 lg:p-16 w-full lg:max-w-4xl max-w-lg md:max-w-2xl xl:max-w-none w-full z-0" tabIndex={0}>
                <h1 className="text-2xl font-bold font-['Inter'] text-white !text-white text-left">Prefer to speak with our data experts directly?</h1>
                <p className="mx-auto max-w-3xl body-text !text-white text-left mt-5">
                  We understand that some conversations are better handled in person. If you&apos;d rather speak with one of our data experts directly, you can schedule a free, no-obligation consultation. Click the button below to book a time that suits you, and we&apos;ll be happy to discuss your data management needs.
                </p>
                <div className="flex flex-col  md:flex-row md:pr-16 pr-4 mt-8">
                  <Link
                    href="https://calendar.app.google/LT4acVdKn3Cxm2MXA"
                    className="btn-primary"
                    aria-label="Schedule a call"
                    target="_blank"
                  >
                    Schedule a call
                  </Link>
                </div>
                <svg
                  viewBox="0 0 1024 1024"
                  className="absolute left-1/2 top-0 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
                  aria-hidden="true"
                >
                  <circle cx={512} cy={512} r={512} fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)" fillOpacity="0.7" />
                  <defs>
                    <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
                      <stop stopColor="#fb923c" />
                      <stop offset={1} stopColor="#fb923c" />
                    </radialGradient>
                  </defs>
                </svg>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}
